export enum FormStatusType {
  CREATE = 0,
  EDIT = 1,
  VIEW = 2,
  ASSIGN,
  REMOVE,
  DUPLICATE,
}
